import Language from "@bimproject/language";
import styled from "styled-components";

import LanguageLabel from "./LanguageLabel";
import Button from "../../actions/Button";

export default function LanguageSelect(props: LanguageSelectProps) {
    const {
        languages,
        languagesDisabled = [],
        languagesHighlighted = [],
        onSelect,
        ...restProps
    } = props;
    return (
        <Styled { ...restProps }>
            {
                languages
                    .toSorted(Language.compare)
                    .map(
                        (language) => (
                            <LanguageButton
                                data-suggested={ languagesHighlighted.includes(language) ? true : undefined }
                                disabled={ languagesDisabled.includes(language) }
                                key={ language }
                                onClick={ () => onSelect(language) }
                            >
                                <LanguageLabel language={ language } />
                            </LanguageButton>
                        )
                    )
            }
        </Styled>
    );
}

interface LanguageSelectProps {
    languages: string[]
    languagesDisabled?: string[]
    languagesHighlighted?: string[]
    onSelect: (language: string) => unknown
}

const Styled = styled.div`
    display: grid;
    font-family: sans-serif;
    gap: 8px;
    grid-auto-flow: row;
    grid-template-columns: repeat(auto-fit, minmax(176px, 1fr));
    flex: auto;
    overflow: auto;
    padding: 8px;
`;

const LanguageButton = styled(Button)`
    width: auto;

    &:disabled {
        border: transparent;
        opacity: .2;
    }
    &:enabled:not(:hover)[data-suggested] {
        border-color: #0007;
    }
`;
